/* Aura Bundle — comportamento do widget de oferta.
 *
 * Principios que valem pro arquivo inteiro:
 *  - FALHA ABERTO. Se algo der errado, o widget se cala e a pagina continua
 *    sendo a pagina normal do tema, com o botao de comprar funcionando.
 *  - Zero chamada de rede pra renderizar. A configuracao ja veio do Liquid.
 *  - Quando todas as unidades sao da mesma variante, quem adiciona ao carrinho
 *    e o proprio tema (so ajustamos a quantidade). Assim a gaveta do tema abre
 *    sozinha e nao precisamos conhecer o tema.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------- dinheiro */

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var f = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = f.match(placeholder);
    var value;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return f.replace(placeholder, value);
  }

  /* ---------------------------------------------------------------- preco
   * Espelho exato da conta que o Liquid faz no servidor. Se as duas contas
   * divergirem, o preco pisca ao trocar de variante — por isso sao iguais
   * ate no arredondamento. */

  function roundUpTo(cents, mode) {
    var c = Math.round(cents);
    if (!mode || mode === 'none') return c;

    var ending = mode === '.90' ? 90 : mode === '.95' ? 95 : mode === '.99' ? 99 : 0;
    var base = Math.floor(c / 100) * 100;
    var cand = base + ending;
    if (cand < c) cand += 100;
    return cand;
  }

  function barPrices(bar, unitBase, compareBase, rounding) {
    var qty = bar.qty || 1;
    var unit;
    var total;

    if (bar.discountType === 'specific') {
      total = Math.round(bar.discountValue * 100);
      unit = Math.floor(total / qty);
    } else {
      if (bar.discountType === 'percentage') {
        unit = Math.round((unitBase * (100 - bar.discountValue)) / 100);
      } else {
        unit = unitBase;
      }
      unit = roundUpTo(unit, rounding);
      total = unit * qty;
    }

    return {
      unit: unit,
      total: total,
      compare: compareBase * qty,
      unitCompare: compareBase
    };
  }

  /* ------------------------------------------------------------ utilitarios */

  function closestSection(el) {
    return (
      el.closest('.shopify-section') ||
      el.closest('section') ||
      el.closest('[id^="shopify-section"]') ||
      document
    );
  }

  function findForm(root, cfg) {
    var manual = cfg.settings && cfg.settings.formSelector;
    if (manual) {
      var picked = document.querySelector(manual);
      if (picked) return picked;
    }

    // a pagina costuma ter mais de um formulario de carrinho (o de compra e o
    // da barra fixa, por exemplo). O que vale e o que o cliente realmente envia:
    // tem variante E tem botao de enviar. Pegar o outro faz o tema mandar 1
    // unidade mesmo com a barra de 2 escolhida
    function temBotao(form) {
      return !!form.querySelector('button[name="add"], [type="submit"]');
    }

    // a gaveta de carrinho e os upsells dela tambem tem formulario de /cart/add,
    // e ficam no corpo da pagina em toda PDP. Assumir um deles faz o cliente
    // levar o produto do upsell no lugar do produto da pagina
    function ehDeFora(form) {
      if (!form.closest) return false;
      return !!form.closest(
        'cart-drawer, .cart-drawer, #shopify-section-cart-drawer, ' +
        '[data-is-cart-upsell], .upsell, .upsells-container, ' +
        '.drawer, .cart-drawer-upsells-container'
      );
    }

    var scopes = [closestSection(root), document];
    var comId = null;
    var comBotao = null;
    var qualquer = null;

    for (var s = 0; s < scopes.length; s++) {
      var forms = scopes[s].querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        if (ehDeFora(f)) continue;
        var id = !!f.querySelector('[name="id"]');
        var botao = temBotao(f);
        if (id && botao) return f;
        if (id && !comId) comId = f;
        if (botao && !comBotao) comBotao = f;
        if (!qualquer) qualquer = f;
      }
    }

    return comBotao || comId || qualquer;
  }

  /**
   * Coloca o widget do app embed no lugar certo da pagina.
   *
   * O embed nasce no fim do corpo porque e assim que a Shopify injeta app embed.
   * O lugar dele e o mesmo do bloco de secao: logo acima do botao de comprar.
   * Enquanto nao encontra esse lugar, o widget fica escondido — pagina sem o
   * widget continua sendo a pagina normal do tema, com o botao funcionando.
   */
  function posicionarEmbed(root, form) {
    if (!root.hasAttribute('data-aura-embed')) return true;

    var alvo = null;

    if (form) {
      // o ponto exato e o bloco dos botoes de compra; sem ele, o proprio form
      alvo =
        form.querySelector('.product-form__buttons') ||
        form.querySelector('[name="add"]') ||
        form;
      if (alvo !== form && alvo.closest) {
        alvo = alvo.closest('.product-form__buttons') || alvo;
      }
      // o widget entra antes do container que segura o botao
      var subir = alvo.closest ? alvo.closest('product-form, .product-form') : null;
      if (subir && subir.parentNode) alvo = subir;
    }

    if (!alvo || !alvo.parentNode) return false;

    alvo.parentNode.insertBefore(root, alvo);
    root.removeAttribute('hidden');
    return true;
  }

  function findNativePicker(root) {
    var scope = closestSection(root);
    var found = [];
    var selectors = [
      'variant-selects',
      'variant-radios',
      'variant-picker',
      '.product-variant-picker',
      '.product-form__variants',
      '[data-product-option]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = scope.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (found.indexOf(nodes[j]) === -1) found.push(nodes[j]);
      }
      if (found.length) break;
    }
    return found;
  }

  /* ------------------------------------------------------------- instancia */

  function Bundle(root) {
    var script = root.querySelector('[data-aura-config]');
    if (!script) return;

    var cfg;
    try {
      cfg = JSON.parse(script.textContent);
    } catch (err) {
      return;
    }
    if (!cfg || !cfg.bars || !cfg.bars.length) return;

    this.root = root;
    this.cfg = cfg;
    this.form = findForm(root, cfg);

    // app embed: sair do fim do corpo e assumir o lugar do bloco de secao
    if (!posicionarEmbed(root, this.form)) return;
    this.variants = cfg.product.variants || [];
    this.byId = {};
    this.suppressSync = false;

    for (var i = 0; i < this.variants.length; i++) {
      this.byId[String(this.variants[i].id)] = this.variants[i];
    }

    this.current = this.readNativeVariant() || this.firstAvailable();
    // ultimo valor VISTO no seletor do tema: e a mudanca dele que manda, nunca a
    // diferenca entre tema e widget (senao a unidade #1 nunca sai do lugar)
    this.lastNative = this.current ? this.current.id : null;
    // preselected 0 significa nenhuma barra marcada: ate o cliente escolher, a
    // pagina se comporta como a pagina normal do tema
    this.barIndex = cfg.preselected === 0 ? 0 : cfg.preselected || 1;
    this.units = [];

    this.bind();
    if (this.barIndex) this.selectBar(this.barIndex, true);
    this.takeOver();
    this.watchNative();

    this.log('pronto', {
      oferta: cfg.dealHandle,
      barras: cfg.bars.length,
      formulario: !!this.form
    });
  }

  Bundle.prototype.log = function () {
    if (!this.cfg.settings || !this.cfg.settings.debug) return;
    var args = ['[aura-bundle]'].concat([].slice.call(arguments));
    // eslint-disable-next-line no-console
    console.log.apply(console, args);
  };

  Bundle.prototype.bar = function () {
    return this.cfg.bars[this.barIndex - 1] || this.cfg.bars[0];
  };

  Bundle.prototype.firstAvailable = function () {
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].available) return this.variants[i];
    }
    return this.variants[0] || null;
  };

  Bundle.prototype.readNativeVariant = function () {
    if (!this.form) return null;
    var input = this.form.querySelector('[name="id"]');
    if (!input || !input.value) return null;
    return this.byId[String(input.value)] || null;
  };

  /* ------------------------------------------------------------ selecao */

  Bundle.prototype.bind = function () {
    var self = this;

    var inputs = this.root.querySelectorAll('.aura-bar__input');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', function () {
        if (this.disabled) return;
        self.selectBar(parseInt(this.value, 10), false);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        self.onSubmit(e);
      }, true);

      // muitos temas adicionam ao carrinho no CLIQUE, com fetch proprio, e nunca
      // disparam o envio do formulario. Sem escutar o clique, o caminho de
      // varias cores nunca seria interceptado e o cliente levaria uma unidade so
      var botoes = this.form.querySelectorAll('button[name="add"], [type="submit"]');
      for (var b = 0; b < botoes.length; b++) {
        botoes[b].addEventListener('click', function (e) {
          self.onAddClick(e);
        }, true);
      }
    }
  };

  // upsells com caixinha marcada do cartao escolhido
  Bundle.prototype.upsellItems = function () {
    if (!this.barIndex) return [];
    var caixa = this.root.querySelector('[data-aura-upsells="' + this.barIndex + '"]');
    if (!caixa) return [];

    var marcados = caixa.querySelectorAll('[data-aura-upsell]');
    var itens = [];
    for (var i = 0; i < marcados.length; i++) {
      if (!marcados[i].checked) continue;
      var id = parseInt(marcados[i].getAttribute('data-aura-upsell-variant'), 10);
      var qtd = parseInt(marcados[i].getAttribute('data-aura-upsell-qty'), 10) || 1;
      if (id) itens.push({ id: id, quantity: qtd, properties: { _aura_upsell: this.bar().title || '' } });
    }
    return itens;
  };

  // brindes destravados pela barra escolhida entram no carrinho junto do pacote
  Bundle.prototype.giftItems = function () {
    if (!this.barIndex) return [];

    var cartoes = this.root.querySelectorAll('[data-aura-gift]');
    var itens = [];
    for (var i = 0; i < cartoes.length; i++) {
      var unlock = parseInt(cartoes[i].getAttribute('data-aura-unlock'), 10) || 1;
      if (this.barIndex < unlock) continue;
      var id = parseInt(cartoes[i].getAttribute('data-aura-gift-variant'), 10);
      var qtd = parseInt(cartoes[i].getAttribute('data-aura-gift-qty'), 10) || 1;
      if (id) itens.push({ id: id, quantity: qtd, properties: { _aura_gift: this.bar().title || '' } });
    }
    return itens;
  };

  Bundle.prototype.onAddClick = function (e) {
    // sem barra escolhida o widget nao interfere: a pagina e a pagina do tema
    if (!this.barIndex) return;

    var groups = this.groups();
    var extras = this.upsellItems().concat(this.giftItems());

    // uma unidade so, de uma variante so, sem upsell marcado: o tema faz tudo,
    // inclusive abrir a gaveta dele. Acima disso o widget assume, porque nem
    // todo tema respeita a quantidade do formulario no caminho de clique
    var unidades = 0;
    for (var g = 0; g < groups.length; g++) unidades += groups[g].qty || 0;
    if (groups.length <= 1 && !extras.length && unidades <= 1) {
      this.syncForm();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    this.addAll(groups, extras);
  };

  Bundle.prototype.addAll = function (groups, extras) {
    var self = this;
    var titulo = this.bar().title || '';
    var itens = groups.map(function (g) {
      return { id: g.id, quantity: g.qty, properties: { _aura_bundle: titulo } };
    });
    itens = itens.concat(extras || []);

    this.log('adicionando o pacote inteiro', itens);

    return fetch(this.cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        return res.json();
      })
      .then(function () {
        self.avisarTema();
        self.afterAdd();
      })
      .catch(function (err) {
        // o cliente fica na pagina do produto: tirar ele daqui pra /cart custa a
        // venda e nao resolve nada
        self.log('falhou ao adicionar o pacote', err);
      });
  };

  // a gaveta do tema (ou do app de carrinho) costuma escutar um destes avisos
  Bundle.prototype.avisarTema = function () {
    var avisos = ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'];
    for (var i = 0; i < avisos.length; i++) {
      document.dispatchEvent(new CustomEvent(avisos[i], { bubbles: true }));
    }
    if (window.Shopify && window.Shopify.onCartUpdate) {
      try {
        window.Shopify.onCartUpdate();
      } catch (err) {
        this.log('onCartUpdate reclamou', err);
      }
    }
  };

  Bundle.prototype.selectBar = function (index, initial) {
    var bar = this.cfg.bars[index - 1];
    if (!bar || bar.soldOut) return;

    this.barIndex = index;

    var bars = this.root.querySelectorAll('.aura-bar');
    for (var i = 0; i < bars.length; i++) {
      var on = i === index - 1;
      bars[i].classList.toggle('is-selected', on);
      var card = bars[i].closest ? bars[i].closest('.aura-bar-wrap') : null;
      if (card) card.classList.toggle('is-selected', on);
      var input = bars[i].querySelector('.aura-bar__input');
      if (input && input.checked !== on) input.checked = on;
    }

    // brinde destrava quando a barra escolhida alcanca o degrau dele
    var gifts = this.root.querySelectorAll('[data-aura-gift]');
    for (var g = 0; g < gifts.length; g++) {
      var unlock = parseInt(gifts[g].getAttribute('data-aura-unlock'), 10) || 1;
      var aberto = index >= unlock;
      gifts[g].classList.toggle('aura-gift--locked', !aberto);
      var titulo = gifts[g].querySelector('[data-aura-gift-title]');
      if (titulo) {
        titulo.textContent = aberto
          ? gifts[g].getAttribute('data-aura-title') || ''
          : gifts[g].getAttribute('data-aura-locked-title') || '';
      }
    }

    // as unidades comecam todas na variante atual e o cliente muda depois
    var qty = bar.qty || 1;
    var next = [];
    for (var u = 0; u < qty; u++) {
      next.push(this.units[u] || (this.current && this.current.id) || null);
    }
    this.units = next;

    this.renderVariants();
    this.renderPrices();
    this.syncForm();

    if (!initial) this.log('barra', index, 'unidades', this.units.slice());
  };

  /* -------------------------------------------------------------- precos */

  Bundle.prototype.renderPrices = function () {
    var cfg = this.cfg;
    var unitBase = this.current ? this.current.price : 0;
    var compareBase = unitBase;

    if (cfg.useCompareAt && this.current && this.current.compareAt > unitBase) {
      compareBase = this.current.compareAt;
    }

    var bars = this.root.querySelectorAll('.aura-bar');

    for (var i = 0; i < cfg.bars.length; i++) {
      var node = bars[i];
      if (!node) continue;

      var p = barPrices(cfg.bars[i], unitBase, compareBase, cfg.rounding);
      var main = cfg.showPerItem ? p.unit : p.total;
      var mainCompare = cfg.showPerItem ? p.unitCompare : p.compare;
      var alt = cfg.showPerItem ? p.total : p.unit;

      var priceEl = node.querySelector('[data-aura-price]');
      if (priceEl) priceEl.textContent = this.money(main);

      var fullEl = node.querySelector('[data-aura-full]');
      if (fullEl) {
        if (mainCompare > main) {
          fullEl.textContent = this.money(mainCompare);
          fullEl.hidden = false;
        } else {
          fullEl.textContent = '';
          fullEl.hidden = true;
        }
      }

      var altEl = node.querySelector('[data-aura-alt]');
      if (altEl) {
        altEl.textContent = this.money(alt) + (cfg.unitLabel ? ' ' + cfg.unitLabel : '');
      }

      // Tokens de texto: o Liquid ja escreveu o valor do primeiro carregamento,
      // e aqui eles acompanham a troca de variante como qualquer outro preco.
      var saved = p.compare - p.total;
      if (saved < 0) saved = 0;

      var npEls = node.querySelectorAll('[data-aura-newprice]');
      for (var n = 0; n < npEls.length; n++) npEls[n].textContent = this.money(p.unit);

      var svEls = node.querySelectorAll('[data-aura-saved]');
      for (var v = 0; v < svEls.length; v++) svEls[v].textContent = this.money(saved);
    }
  };

  Bundle.prototype.money = function (cents) {
    var value = cents;
    if (this.cfg.noDecimals) value = Math.round(cents / 100) * 100;
    var out = formatMoney(value, this.cfg.moneyFormat);
    if (this.cfg.noDecimals) out = out.replace(/([.,])00\b/, '');
    return out;
  };

  /* ----------------------------------------------------------- variantes */

  // a bolinha de cor ao lado do nome, como no widget de referencia. Sem dado de
  // cor cadastrado na loja, ela simplesmente nao aparece


  /* ------------------------------------------- opcoes encadeadas por unidade */

  // A referencia nao oferece um select com a variante inteira: ela oferece um
  // select POR OPCAO (cor, tamanho), e o da direita so lista o que existe para
  // o que foi escolhido na esquerda. Sem isso o widget ofereceria combinacao
  // inexistente e o add falharia em silencio.

  // "Pick Your Colour:" e "pick your colour" sao a mesma opcao: o lojista escreve
  // o nome de um jeito no produto e de outro na configuracao, e a bolinha sumia
  function chaveDeOpcao(nome) {
    return String(nome == null ? '' : nome)
      .replace(/\s*:\s*$/, '')
      .trim()
      .toLowerCase();
  }

  function ehOpcaoComSwatch(cfg, nome) {
    var lista = cfg.swatchOptions;
    if (!lista || !lista.length) return false;
    var alvo = chaveDeOpcao(nome);
    for (var i = 0; i < lista.length; i++) {
      if (chaveDeOpcao(lista[i]) === alvo) return true;
    }
    return false;
  }

  // O que representa o valor na miniatura. A referencia mostra a FOTO do produto
  // naquela cor; a bolinha lisa entra so quando a loja cadastrou cor e nao ha foto.
  function artePraValor(cfg, variants, optIndex, valor) {
    var opt = (cfg.product.options || [])[optIndex];
    var lista = (opt && opt.swatches) || [];
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].value === valor) {
        if (lista[i].image) return {image: lista[i].image};
        if (lista[i].color) return {color: lista[i].color};
        break;
      }
    }
    for (var v = 0; v < variants.length; v++) {
      var va = variants[v];
      if (va.options && va.options[optIndex] === valor && va.image) return {image: va.image};
    }
    return null;
  }

  Bundle.prototype.valoresPossiveis = function (escolha, optIndex) {
    var options = this.cfg.product.options || [];
    var vistos = [];
    var saida = [];

    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (!v.options) continue;

      var serve = true;
      for (var o = 0; o < optIndex; o++) {
        if (v.options[o] !== escolha[o]) { serve = false; break; }
      }
      if (!serve) continue;

      var valor = v.options[optIndex];
      var idx = vistos.indexOf(valor);
      if (idx === -1) {
        vistos.push(valor);
        saida.push({valor: valor, disponivel: !!v.available});
      } else if (v.available) {
        saida[idx].disponivel = true;
      }
    }

    // respeita a ordem cadastrada na loja, nao a ordem em que as variantes vieram
    var ordem = (options[optIndex] && options[optIndex].values) || [];
    if (ordem.length) {
      saida.sort(function (a, b) {
        var ia = ordem.indexOf(a.valor);
        var ib = ordem.indexOf(b.valor);
        return (ia < 0 ? 9999 : ia) - (ib < 0 ? 9999 : ib);
      });
    }
    return saida;
  };

  Bundle.prototype.variantePorOpcoes = function (escolha) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (!v.options) continue;
      var igual = true;
      for (var o = 0; o < escolha.length; o++) {
        if (v.options[o] !== escolha[o]) { igual = false; break; }
      }
      if (igual) return v;
    }
    return null;
  };

  // trocar a cor pode invalidar o tamanho escolhido: a da direita cai no primeiro
  // valor que existe, em vez de ficar apontando pra combinacao que sumiu
  Bundle.prototype.ajustarEscolha = function (escolha) {
    var options = this.cfg.product.options || [];
    for (var o = 0; o < options.length; o++) {
      var possiveis = this.valoresPossiveis(escolha, o);
      if (!possiveis.length) break;

      var ok = false;
      for (var i = 0; i < possiveis.length; i++) {
        if (possiveis[i].valor === escolha[o]) { ok = true; break; }
      }
      if (ok) continue;

      var escolhido = null;
      for (var j = 0; j < possiveis.length; j++) {
        if (possiveis[j].disponivel) { escolhido = possiveis[j].valor; break; }
      }
      escolha[o] = escolhido || possiveis[0].valor;
    }
    return escolha;
  };

  Bundle.prototype.variantContainer = function () {
    // o painel vive dentro do proprio cartao escolhido, nos dois layouts
    return this.root.querySelector('[data-aura-variants="' + this.barIndex + '"]');
  };

  Bundle.prototype.renderVariants = function () {
    var self = this;
    var cfg = this.cfg;
    var bar = this.bar();
    var qty = bar.qty || 1;
    var options = cfg.product.options || [];

    var all = this.root.querySelectorAll('[data-aura-variants]');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.remove('is-open');
      all[i].innerHTML = '';
    }

    var onlyOne = this.variants.length <= 1;
    var wants = cfg.differentVariants && qty > 1;
    if (cfg.differentVariants && qty === 1 && cfg.showVariantsSingle) wants = true;
    if (!wants || onlyOne || !options.length) return;

    var box = this.variantContainer();
    if (!box) return;

    // ponto de partida de cada unidade: o que o tema tem escolhido agora
    var base = (this.current && this.current.options) || (this.variants[0] || {}).options || [];
    if (!this.unitOpts) this.unitOpts = [];

    // Quem nomeia as opcoes e este cabecalho, uma vez so, acima das unidades. A
    // linha de baixo traz apenas "#1"/"#2" — e, na barra de uma unidade, nem
    // isso: o nome aparecia duas vezes seguidas e o seletor ficava sem espaco.
    var nomes = document.createElement('div');
    nomes.className = 'aura-unit-names';
    nomes.textContent = options
      .map(function (o) { return (o.name || '').replace(/\s*:\s*$/, ''); })
      .filter(Boolean)
      .join(', ');
    if (nomes.textContent) box.appendChild(nomes);

    for (var u = 0; u < qty; u++) {
      if (!this.unitOpts[u]) this.unitOpts[u] = base.slice();
      this.ajustarEscolha(this.unitOpts[u]);
      var variante = this.variantePorOpcoes(this.unitOpts[u]);
      if (variante) this.units[u] = variante.id;
      box.appendChild(this.linhaDaUnidade(u, qty, options));
    }

    box.classList.add('is-open');
  };

  Bundle.prototype.linhaDaUnidade = function (u, qty, options) {
    var row = document.createElement('div');
    row.className = 'aura-unit' + (qty === 1 ? ' aura-unit--sozinha' : '');
    row.setAttribute('data-aura-unit-row', String(u));

    if (qty > 1) {
      var label = document.createElement('span');
      label.className = 'aura-unit__label';
      label.textContent = '#' + (u + 1);
      row.appendChild(label);
    }

    for (var o = 0; o < options.length; o++) {
      row.appendChild(this.campoDaOpcao(u, o, options[o]));
    }

    return row;
  };

  Bundle.prototype.campoDaOpcao = function (u, optIndex, option) {
    var self = this;
    var cfg = this.cfg;
    var escolha = this.unitOpts[u];

    var field = document.createElement('span');
    field.className = 'aura-unit__field';

    var comSwatch = ehOpcaoComSwatch(cfg, option.name);
    var dot = null;
    if (comSwatch) {
      dot = document.createElement('span');
      dot.className = 'aura-unit__swatch';
      field.appendChild(dot);
    }

    var valor = document.createElement('span');
    valor.className = 'aura-unit__value';
    field.appendChild(valor);

    var select = document.createElement('select');
    select.className = 'aura-unit__select';
    select.setAttribute('data-aura-unit', String(u));
    select.setAttribute('data-aura-opt', String(optIndex));
    select.setAttribute('aria-label', (option.name || 'Option') + ' #' + (u + 1));
    field.appendChild(select);

    var possiveis = this.valoresPossiveis(escolha, optIndex);
    for (var i = 0; i < possiveis.length; i++) {
      var item = possiveis[i];
      if (!item.disponivel && cfg.hideUnavailable) continue;

      var opt = document.createElement('option');
      opt.value = item.valor;
      opt.textContent = item.disponivel ? item.valor : item.valor + ' (Sold out)';
      if (!item.disponivel) opt.disabled = true;
      if (item.valor === escolha[optIndex]) opt.selected = true;
      select.appendChild(opt);
    }

    valor.textContent = escolha[optIndex] || '';

    if (dot) {
      var arte = artePraValor(cfg, this.variants, optIndex, escolha[optIndex]);
      if (!arte) {
        dot.style.display = 'none';
        field.classList.remove('aura-unit__field--swatch');
      } else {
        dot.style.display = '';
        dot.style.background = arte.image
          ? 'url(' + arte.image + ') center/cover'
          : arte.color;
        field.classList.add('aura-unit__field--swatch');
      }
    }

    select.addEventListener('change', function () {
      self.unitOpts[u][optIndex] = this.value;
      self.ajustarEscolha(self.unitOpts[u]);

      var variante = self.variantePorOpcoes(self.unitOpts[u]);
      if (variante) {
        self.units[u] = variante.id;
        if (u === 0) {
          self.current = variante;
          self.pushToNative();
          self.renderPrices();
        }
      }

      // a linha inteira e refeita: trocar a cor muda a lista de tamanhos
      var linha = self.root.querySelector('[data-aura-unit-row="' + u + '"]');
      if (linha && linha.parentNode) {
        var bar = self.bar();
        linha.parentNode.replaceChild(
          self.linhaDaUnidade(u, bar.qty || 1, cfg.product.options || []),
          linha
        );
      }

      self.syncForm();
      self.log('unidade', u + 1, '->', self.unitOpts[u].join(' / '));
    });

    return field;
  };

  /* -------------------------------------------------- conversa com o tema */

  Bundle.prototype.watchNative = function () {
    var self = this;
    if (!this.form || this.cfg.disableSync) return;

    var pull = function () {
      if (self.suppressSync) return;
      var v = self.readNativeVariant();
      if (!v) return;

      // o seletor do tema continua no mesmo lugar: nada a fazer. Sem esta
      // comparacao, escolher outra cor na unidade #1 era desfeito no proximo
      // giro do relogio, porque o widget divergia do tema de proposito.
      if (self.lastNative == null) self.lastNative = v.id;
      if (v.id === self.lastNative) return;
      self.lastNative = v.id;

      if (self.current && v.id === self.current.id) return;

      self.current = v;
      self.units[0] = v.id;
      // a primeira unidade e a variante da pagina: quando o tema troca, ela troca
      if (self.unitOpts && self.unitOpts[0] && v.options) self.unitOpts[0] = v.options.slice();
      self.renderVariants();
      self.renderPrices();
      self.syncForm();
      self.log('tema trocou a variante ->', v.id);
    };

    this.form.addEventListener('change', pull);
    ['variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'].forEach(
      function (name) {
        document.addEventListener(name, pull);
      }
    );

    // rede de seguranca pros temas que trocam a variante sem avisar ninguem
    setInterval(function () {
      if (document.hidden) return;
      pull();
    }, 400);
  };

  Bundle.prototype.pushToNative = function () {
    if (!this.form || !this.current || this.cfg.disableSync) return;

    var self = this;
    this.suppressSync = true;

    var pickers = findNativePicker(this.root);
    var touched = false;
    var options = this.current.options || [];

    for (var p = 0; p < pickers.length; p++) {
      var holder = pickers[p];

      var radios = holder.querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (options.indexOf(radios[r].value) !== -1 && !radios[r].checked) {
          radios[r].checked = true;
          touched = true;
        }
      }

      var selects = holder.querySelectorAll('select');
      for (var s = 0; s < selects.length; s++) {
        var want = options[s];
        if (want != null && selects[s].value !== want) {
          selects[s].value = want;
          touched = true;
        }
      }

      if (touched) holder.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var idInput = this.form.querySelector('[name="id"]');
    if (idInput && String(idInput.value) !== String(this.current.id)) {
      idInput.value = String(this.current.id);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setTimeout(function () {
      var agora = self.readNativeVariant();
      if (agora) self.lastNative = agora.id;
      self.suppressSync = false;
    }, 250);
  };

  /* ------------------------------------------- quantidade e pagamento expresso */

  Bundle.prototype.groups = function () {
    var order = [];
    var map = {};

    for (var i = 0; i < this.units.length; i++) {
      var id = String(this.units[i] || (this.current && this.current.id));
      if (!id || id === 'null') continue;
      if (!map[id]) {
        map[id] = { id: parseInt(id, 10), qty: 0 };
        order.push(map[id]);
      }
      map[id].qty += 1;
    }
    return order;
  };

  Bundle.prototype.syncForm = function () {
    if (!this.form) return;

    var groups = this.groups();
    var primary = groups[0] || { qty: this.bar().qty || 1 };

    var qtyInput = this.form.querySelector('[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.setAttribute('data-aura-injected', '1');
      this.form.appendChild(qtyInput);
    }
    // so avisamos o tema quando o numero muda de verdade: alguns temas
    // re-renderizam o formulario a cada change e isso atrapalharia o envio
    if (qtyInput.value !== String(primary.qty)) {
      qtyInput.value = String(primary.qty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.setProperty('_aura_bundle', this.bar().title || '');

    var multi = groups.length > 1;
    this.form.classList.toggle('aura-multi-variant', multi && this.cfg.settings.hideExpressMulti);
    closestSection(this.root).classList &&
      closestSection(this.root).classList.toggle(
        'aura-multi-variant',
        multi && this.cfg.settings.hideExpressMulti
      );
  };

  Bundle.prototype.setProperty = function (key, value) {
    if (!this.form) return;
    var name = 'properties[' + key + ']';
    var input = this.form.querySelector('input[name="' + name + '"][data-aura-injected]');

    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-aura-injected', '1');
      this.form.appendChild(input);
    }
    input.value = value;
  };

  /* ---------------------------------------------------------- takeover */

  Bundle.prototype.takeOver = function () {
    if (!this.form) return;

    this.root.classList.add('aura-took-over');
    closestSection(this.root).classList &&
      closestSection(this.root).classList.add('aura-took-over');

    // so escondemos o seletor do tema DEPOIS de ter certeza de que assumimos
    if (this.cfg.hideVariantPicker) {
      var pickers = findNativePicker(this.root);
      for (var i = 0; i < pickers.length; i++) {
        pickers[i].classList.add('aura-hidden-native-picker');
      }
    }
  };

  /* ------------------------------------------------------ adicionar ao carrinho */

  Bundle.prototype.onSubmit = function (e) {
    var self = this;
    var form = this.form;

    if (form.__auraPass) {
      form.__auraPass = false;
      return;
    }

    if (!this.barIndex) return;

    var groups = this.groups();
    var extras = this.upsellItems().concat(this.giftItems());
    if (groups.length <= 1 && !extras.length) {
      // caminho normal: uma variante so. O tema adiciona e abre a propria gaveta.
      this.syncForm();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    this.addAll(groups, extras);
  };

  Bundle.prototype.addPrimaryDirectly = function (group) {
    var self = this;

    fetch(this.cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: group.id,
            quantity: group.qty,
            properties: { _aura_bundle: self.bar().title || '' }
          }
        ]
      })
    }).then(function () {
      self.afterAdd();
    });
  };

  /**
   * Abre a gaveta do tema depois de uma adicao feita pelo app.
   *
   * Quando o app adiciona por conta propria (varias variantes, brinde, upsell),
   * o tema nao fica sabendo e nao abre nada — e o cliente acabava jogado na
   * pagina do carrinho. Aqui o app cumpre o contrato do proprio tema: pede as
   * secoes do carrinho e manda a gaveta se redesenhar e abrir.
   */
  /**
   * O tema marca a gaveta como vazia e o CSS da familia Dawn esconde os itens e
   * o rodape (onde fica o botao de checkout) enquanto essa marca existe. Depois
   * de redesenhar com o carrinho cheio, a marca precisa sair na mao: senao o
   * cliente ve um painel branco e nao tem como seguir pro pagamento.
   */
  function destravarGaveta(gaveta) {
    if (!gaveta) return;
    if (!gaveta.querySelector('.cart-item, cart-drawer-items .cart-item')) return;
    gaveta.classList.remove('is-empty');
    var inner = gaveta.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  Bundle.prototype.abrirGaveta = function () {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta) return Promise.resolve(false);

    var raiz =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(raiz + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (dados) {
        // caminho do proprio tema: ele sabe trocar o conteudo e abrir
        if (typeof gaveta.renderContents === 'function') {
          gaveta.renderContents({ sections: dados });
          destravarGaveta(gaveta);
          // o proprio tema redesenha de novo logo depois de abrir
          setTimeout(function () { destravarGaveta(gaveta); }, 120);
          setTimeout(function () { destravarGaveta(gaveta); }, 600);
          // alguns temas da familia Dawn redesenham sem abrir
          if (typeof gaveta.open === 'function' && !gaveta.classList.contains('active')) {
            gaveta.open();
          }
          return true;
        }

        // tema sem esse metodo: troca na mao e abre
        var doc = new DOMParser().parseFromString(dados['cart-drawer'] || '', 'text/html');
        var novoConteudo = doc.querySelector('#CartDrawer');
        var atual = document.querySelector('#CartDrawer');
        if (novoConteudo && atual) atual.innerHTML = novoConteudo.innerHTML;

        var novaBolha = doc.querySelector('#cart-icon-bubble');
        var bolha = document.querySelector('#cart-icon-bubble');
        if (novaBolha && bolha) bolha.innerHTML = novaBolha.innerHTML;

        destravarGaveta(gaveta);
        if (typeof gaveta.open === 'function') gaveta.open();
        setTimeout(function () { destravarGaveta(gaveta); }, 120);
        return true;
      })
      .catch(function () {
        return false;
      });
  };

  Bundle.prototype.afterAdd = function () {
    var self = this;

    if (this.cfg.skipCart) {
      window.location.href = '/checkout';
      return;
    }

    var modo = this.cfg.settings.afterAdd;
    if (modo === 'none') return;
    if (modo === 'cart') {
      window.location.href = this.cfg.routes.cart;
      return;
    }

    // modo 'theme': primeiro tenta abrir a gaveta do tema. So se nao existir
    // gaveta nenhuma e nada aparecer sozinho e que o cliente vai pro carrinho,
    // pra nunca ficar sem retorno depois de clicar
    this.abrirGaveta().then(function (abriu) {
      if (abriu) return;
      self.esperarRetorno();
    });
  };

  Bundle.prototype.esperarRetorno = function () {
    var self = this;
    setTimeout(function () {
      // gaveta OU notificacao: nos temas da familia Dawn o lojista pode estar em
      // 'notification', que mostra um aviso no topo em vez de abrir gaveta.
      // Sem reconhecer isso, o widget mandava o cliente pra pagina do carrinho
      // e tirava ele da pagina do produto sem necessidade.
      var retorno = document.querySelector(
        '.upcart-cart, cart-drawer.active, cart-drawer[open], .drawer--is-open,' +
        ' .cart-drawer.is-open, [data-cart-drawer].is-open, .js-drawer-open,' +
        ' cart-notification.animate, cart-notification.active, #cart-notification.active,' +
        ' .cart-notification.animate, .cart-notification--active, [id^="cart-notification"].active'
      );
      if (retorno) return;
      // ultima tentativa de abrir a gaveta do tema. Se nem assim, o cliente
      // segue na pagina do produto — a ida pra /cart foi removida de proposito.
      self.abrirGaveta();
    }, 1200);
  };

  /* ------------------------------------------------------------------ boot */

  function boot() {
    var nodes = document.querySelectorAll('[data-aura-bundle]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__auraBooted) continue;
      nodes[i].__auraBooted = true;
      try {
        new Bundle(nodes[i]);
      } catch (err) {
        // falha aberto: a pagina segue funcionando sem o widget
        if (window.console && console.warn) console.warn('[aura-bundle]', err);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // o editor de tema recria secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
